module.exports = __webpack_public_path__ + "static/media/screenshot-3.58c58ee2.png";